export default __webpack_public_path__ + "static/media/logo-aprova-branca.5a6066cd.svg";